import { render } from "./AddKeyword.vue?vue&type=template&id=61b19148&scoped=true"
import script from "./AddKeyword.vue?vue&type=script&lang=js"
export * from "./AddKeyword.vue?vue&type=script&lang=js"

import "./AddKeyword.vue?vue&type=style&index=0&id=61b19148&lang=scss&scoped=true"
import "./AddKeyword.vue?vue&type=style&index=1&id=61b19148&lang=scss"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b19148"]])

export default __exports__